import {
  MESSAGE_OPEN_CHAT,
  MESSAGE_GOT_NEW,
  MESSAGE_SET_RECEIVERS,
  MESSAGE_CLEAN,
  MESSAGE_GET_LATEST_CONVERSATIONS_SUCCESS,
  MESSAGE_GET_LATEST_CONVERSATIONS_ERROR,
  MESSAGE_GET_LATEST_CONVERSATIONS_REQUEST,
  MESSAGE_SEE_CONVERSATION,
  GET_CHAT_MESSAGES_REQUESTING,
  GET_CHAT_MESSAGES_SUCCESS,
  GET_CHAT_MESSAGES_ERROR,
  MESSAGE_OPEN_CONVERSATION_REQUESTING,
  MESSAGE_OPEN_CONVERSATION_SUCCESS,
  MESSAGE_OPEN_CONVERSATION_ERROR,
  MESSAGE_GET_CLIENT_NAME_REQUESTING,
  MESSAGE_GET_CLIENT_NAME_SUCCESS,
  MESSAGE_GET_CLIENT_NAME_ERROR,
  MESSAGE_SENDING,
  MESSAGE_SENT,
  MESSAGE_NOT_SENT,
  NEW_CONVERSATION_TEAM,
  MESSAGE_LIKE_SUCCESS,
  MESSAGE_LIKE_REQUESTING,
  REMOVE_MESSAGE_REQUESTING,
  REMOVE_MESSAGE_ERROR,
  MESSAGE_LIKE_ERROR,
  REMOVE_MESSAGE_SUCCESS,
} from "./constants";
import { LOGOUT } from "../login/constants";
import { UPDATE_TEAM_SUCCESS } from "../team/constants";
import { IMessagesReducer } from "./types";

const initialState: IMessagesReducer = {
  messages: [],
  messagesByIds: {},
  messagesIds: [],
  messagePage: 1,
  loadingMessage: false,
  receiver: { _id: "", picture: "", name: "" },
  conversations: [],
  receivers: [{ _id: "", picture: "", name: "" }],
  conversationId: "",
  error: "",
  chatRequesting: false,
  requesting: false,
  clientNameRequesting: false,
  userSelectedClientName: "",
  isMessageSending: false,
  priorMessages: [],
};

export default (
  state: IMessagesReducer = initialState,
  action,
): IMessagesReducer => {
  switch (action.type) {
    case MESSAGE_OPEN_CHAT: {
      const { priorMessages, conversationId } = action.payload;
      return { ...state, messages: priorMessages, conversationId };
    }

    case UPDATE_TEAM_SUCCESS: {
      const conversations = state.conversations.map(conv => {
        if (conv._id === action.payload.conversationId) {
          conv.name = action.payload.name;
        }
        return conv;
      });
      return {
        ...state,
        conversations: conversations,
      };
    }

    case MESSAGE_SEE_CONVERSATION: {
      const newConversation = state.conversations.map((conv, index) => {
        if (conv._id === action.payload) {
          conv.latestMessage.seen = true;
        }
        return conv;
      });
      return {
        ...state,
        conversations: newConversation,
      };
    }

    case MESSAGE_SENDING: {
      return {
        ...state,
        isMessageSending: true,
      };
    }

    case MESSAGE_SENT: {
      const messageId = action?.payload?._id || "";
      let messagesIds = state.messagesIds;
      let messagesByIds = state.messagesByIds;

      const messages = [action.payload, ...state.messages];

      messagesIds = [messageId, ...state.messagesIds];
      messagesByIds[messageId] = { ...messagesByIds[messageId] || {}, ...action.payload, pending: false }

      return {
        ...state,
        messages,
        messagesIds,
        messagesByIds,
        isMessageSending: false,
      };
    }

    case MESSAGE_NOT_SENT:
      return {
        ...state,
        error: action.payload,
        isMessageSending: false,
      };

    case MESSAGE_GOT_NEW: {
      const messageId = action?.payload?._id || "";
      let messages = state.messages;
      let messagesIds = state.messagesIds;
      let messagesByIds = state.messagesByIds;

      if (!messagesByIds[messageId]) {
        messages = [{ ...action.payload, pending: false }, ...state.messages];
        messagesIds = [messageId, ...state.messagesIds];
      }
      messagesByIds[messageId] = { ...messagesByIds[messageId] || {}, ...action.payload, pending: false }


      // const messages = state.messages.map(message => {
      //   if (message._id === action.payload._id) {
      //     isExistingMessage = true;
      //     return { ...message, ...action.payload, pending: false };
      //   }
      //   return message;
      // });

      return {
        ...state,
        messages,
        messagesIds,
        messagesByIds
      };
    }

    case MESSAGE_SET_RECEIVERS:
      return { ...state, receivers: action.payload };

    case MESSAGE_GET_LATEST_CONVERSATIONS_REQUEST:
      return { ...state, requesting: true };

    case MESSAGE_GET_CLIENT_NAME_SUCCESS: {
      return {
        ...state,
        userSelectedClientName: action.payload,
        clientNameRequesting: false,
      };
    }

    case MESSAGE_GET_CLIENT_NAME_REQUESTING:
      return { ...state, clientNameRequesting: true };

    case MESSAGE_GET_LATEST_CONVERSATIONS_SUCCESS:
      return { ...state, requesting: false, conversations: action.payload };

    case MESSAGE_GET_CLIENT_NAME_ERROR:
      return { ...state, clientNameRequesting: false, error: action.payload };

    case MESSAGE_GET_LATEST_CONVERSATIONS_ERROR:
      return { ...state, requesting: false, error: action.payload };

    case GET_CHAT_MESSAGES_SUCCESS: {
      const { messagesByIds = {}, messagesIds = [], messages = [] } = action.payload;
      return {
        ...state,
        messages: [...state.messages, ...messages],
        messagesByIds: { ...state.messagesByIds, ...messagesByIds },
        messagesIds: [...state.messagesIds, ...messagesIds],
        messagePage: state.messagePage + 1,
        loadingMessage: false,
      };
    }

    case GET_CHAT_MESSAGES_REQUESTING:
      return { ...state, loadingMessage: true };

    case GET_CHAT_MESSAGES_ERROR:
      return {
        ...state,
        loadingMessage: false,
        error: action.payload,
      };

    case MESSAGE_OPEN_CONVERSATION_REQUESTING:
      return { ...state, chatRequesting: true };

    case MESSAGE_OPEN_CONVERSATION_SUCCESS:
      const { priorMessages, conversationId, messagesIds, messagesByIds } = action.payload;
      return {
        ...state,
        chatRequesting: false,
        messages: priorMessages,
        messagesIds,
        messagesByIds,
        conversationId,
      };

    case NEW_CONVERSATION_TEAM:
      return {
        ...state,
        chatRequesting: false,
        messages: [],
        messagesByIds: {},
        messagesIds: [],
        conversationId: action.payload.conversationId,
      };

    case MESSAGE_OPEN_CONVERSATION_ERROR:
      return { ...state, chatRequesting: false };

    case MESSAGE_CLEAN: {
      return { ...initialState, conversations: state.conversations };
    }

    case MESSAGE_LIKE_SUCCESS:
    case MESSAGE_LIKE_REQUESTING: {
      const { messageId, userId } = action?.payload || {};
      let messageToUpdate = state.messagesByIds?.[messageId] || { likedBy: [] };

      if (!messageToUpdate?.likedBy || !messageToUpdate?.likedBy?.includes(userId)) {
        messageToUpdate = { ...messageToUpdate, likedBy: [...(messageToUpdate?.likedBy || []), userId] };
      } else {
        messageToUpdate = { ...messageToUpdate, likedBy: messageToUpdate?.likedBy?.filter(id => id !== userId) };
      }


      const messagesByIds = !messageToUpdate?._id ? state.messagesByIds : { ...state.messagesByIds, [messageId]: messageToUpdate };

      return {
        ...state,
        messagesByIds
      }
    }


    case MESSAGE_LIKE_ERROR: {
      const { messageId, userId } = action?.payload || {};
      const updatedMessages = state.messages.map(message => {
        if (message._id === messageId) {
          const updatedLikedBy = message?.likedBy?.filter(id => id !== userId);
          return {
            ...message,
            likedBy: updatedLikedBy,
          };
        }
        return message;
      });
      return {
        ...state,
        messages: updatedMessages,
      };
    }

    case REMOVE_MESSAGE_SUCCESS:
    case REMOVE_MESSAGE_REQUESTING: {
      const { messageId } = action.payload;
      const date = new Date();
      const messageToUpdate = state.messagesByIds?.[messageId] || {};
      const updatedMessage = { ...messageToUpdate, expireAt: date.setMonth(date.getMonth() + 3) };

      const messagesByIds = !!messageToUpdate?._id ? { ...state.messagesByIds, [messageId]: updatedMessage } : state.messagesByIds;

      return {
        ...state,
        messagesByIds,
      };
    }

    case REMOVE_MESSAGE_ERROR: {
      const { messageId } = action.payload;
      const updatedMessages = state.messages.map(message => {
        if (message._id === messageId) {
          const { expireAt, ...updatedMessage } = message;
          return updatedMessage;
        }
        return message;
      });
      return {
        ...state,
        messages: updatedMessages,
      };
    }

    case LOGOUT:
      return initialState;

    default:
      return state;
  }
};
